import { PASSWORD_REGEXP, EMAIL_REGEXP } from './constants';

export const validateEmailFormat = value => EMAIL_REGEXP.test(value);

export const validatePasswordFormat = value => {
  const regExp = new RegExp(PASSWORD_REGEXP, 'g');
  return regExp.test(value);
};